// extracted by mini-css-extract-plugin
export default {"uploadInput":"FileUpload_uploadInput__p3XMR"};